/**
 * FastAPI error bodies are inconsistent: PipelineError / LocalizedHTTPException
 * use `{detail}`, Starlette HTTPException uses `{message}`, validation uses
 * `{detail: [{msg}]}`.
 */
export function formatApiErrorBody(errorData: unknown): string {
  if (!errorData || typeof errorData !== 'object') return '';
  const body = errorData as Record<string, unknown>;
  const detail = body.detail;
  if (typeof detail === 'string' && detail.trim()) return detail.trim();
  if (Array.isArray(detail)) {
    const parts = detail
      .map((item) =>
        item &&
        typeof item === 'object' &&
        'msg' in item &&
        typeof (item as { msg?: string }).msg === 'string'
          ? (item as { msg: string }).msg
          : ''
      )
      .filter(Boolean);
    if (parts.length) return parts.join(' ');
  }
  if (typeof body.message === 'string' && body.message.trim()) {
    return body.message.trim();
  }
  return '';
}
